export const SET_USER = "SET_USER";
export const CLEAR_USER = "CLEAR_USER";

export const INIT = {
  userId: "",
  languages: [],
};

export default function (state = INIT, { type, payload }) {
  switch (type) {
    case SET_USER:
      return payload;
    case CLEAR_USER:
      console.log("clearing user");
      return INIT;
    default:
      return state;
  }
}
